export const API_BASE = 'https://myprotour.com/api';
export const API_BASE2 = 'https://myprotour.com/api/hotel';
export const MEDIA_BASE = 'https://myprotour.com/';
export const API_FILES = 'https://myprotour.com/api/files/';

export const resolveImage = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return MEDIA_BASE + url.replace(/\\/g, '/');
};
